import Image from "@components/Image";
import React from "react";
import styles from "./CoreItem.module.scss";
import cx from "classnames";

interface IProps {
  data: {
    image: { src: string; alt: string };
    label: string;
    content: string;
  };
}

export default function CoreItem({ data: { image, label, content } }: IProps) {
  return (
    <div className="flex flex-col items-center">
      <Image
        speed={0}
        wrapperProps={{ className: cx(styles.image) }}
        src={image.src}
        alt={image.alt}
        layout="fill"
        objectFit="contain"
      />
      <div className={cx(styles.label)}>{label}</div>
      <div className={cx(styles.content)}>{content}</div>
    </div>
  );
}
